var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Delivery User")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('userid')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.listUserData,
      "name": "userid",
      "id": "userid",
      "placeholder": "Select Delivery User",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.userid),
      callback: function($$v) {
        _vm.userid = $$v
      },
      expression: "userid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('userid')),
      expression: "errors.has('userid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Delivery User.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.srListLoader
    },
    on: {
      "update:active": function($event) {
        _vm.srListLoader = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Force Logout")]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#151B31",
      "font-size": "24px",
      "margin-left": "15px"
    },
    on: {
      "click": _vm.getSRUserList
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Delivery user list"
    }
  })]), _vm._v("   ")])], 1)], 1)])])])])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" User Force Logout")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ee252ad","hasScoped":true}!./src/views/components/deliveryuserlogout/deliveryuserlogout.component.html
// module id = 1166
// module chunks = 1